<template>
  <svg viewBox="0 0 100 100">
    <text
      y="82"
      x="50"
      fill="transparent"
      stroke="currentColor"
      stroke-width="2"
      class="text-8xl font-display"
      text-anchor="middle"
    >
      {{ text }}
    </text>
  </svg>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    text: {
      type: String,
      default: "1",
    },
  },
  setup() {
    return {};
  },
});
</script>
